import React from 'react';
import Logo from "@common/components/logo";
import AppButton from "@common/components/app-button";
import {ReactComponent as PrintIcon} from "@assets/icons/print.svg";
import {ReactComponent as QrCodeIcon} from "@assets/icons/qr-code.svg";
import useModalWithData from "@common/hooks/use-modal-with-data";
import {ModalIds} from "@common/models/enums/modal-ids.enum";
import {ArticleDetails} from "../../../core/models/interfaces/article-details.interface";
import {useLoading} from "../../../core/hooks/use-loading.hook";
import {ArticleToPrintModelData} from "../article-to-print-modal";
import {ArticleQrInfoModalData} from "../article-qr-info-modal";
import SpinnerLoader from "@common/components/spinner-loader";
import {classNames} from "@utils/class-names";

interface PublicArticleHeaderProps {
    article?: ArticleDetails | null;
    hidePrintAction?: boolean;
    hideQrAction?: boolean;
}

const PublicArticleHeader: React.FC<PublicArticleHeaderProps> = ({article, hideQrAction, hidePrintAction}) => {
    const {showModal: showPrintModal} = useModalWithData<ArticleToPrintModelData>(ModalIds.PRINT_ARTICLE);
    const {showModal: showQrInfoModal} = useModalWithData<ArticleQrInfoModalData>(ModalIds.ARTICLE_QR_INFO);
    const {startLoading, isLoading} = useLoading();

    const handlePrint = (): void => {
        if (!article) return;
        startLoading("articleToPrintPrepare");
        showPrintModal({articleData: article});
    };

    const handleQrCode = (): void => {
        if (!article) return;
        const shareUrl = `${window.location.origin}/article/${article.id}`;
        showQrInfoModal({
            title: article.title || "",
            url: shareUrl,
        });
    };

    return (
        <div className="sticky top-0 z-20 bg-white/95 backdrop-blur border-b border-outline-mild">
            <div className="max-w-[1800px] mx-auto flex items-center justify-between h-[72px] px-6">
                <Logo/>
                <div className="flex items-center gap-2">
                    {!hidePrintAction && (
                        <AppButton
                            onClick={handlePrint}
                            loading={false}
                            className={classNames(
                                "border-0 rounded-full !p-3 text-on-surface hover:bg-on-surface/5",
                                isLoading("articleToPrintPrepare") && "!bg-on-surface/5"
                            )}
                        >
                            <div className="flex gap-4 whitespace-nowrap items-center justify-between">
                                <PrintIcon className="w-5 h-5"/>
                                {isLoading("articleToPrintPrepare") && <SpinnerLoader color="#333" size="20"/>}
                            </div>
                        </AppButton>
                    )}
                    {!hideQrAction && (
                        <AppButton
                            onClick={handleQrCode}
                            className="border-0 rounded-full !p-3 text-on-surface hover:bg-on-surface/5"
                        >
                            <QrCodeIcon className="w-5 h-5"/>
                        </AppButton>
                    )}
                </div>
            </div>
        </div>
    );
};

export default PublicArticleHeader;


